import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  layoutGrid: {
    display: 'grid',
    gridTemplateColumns: '220px 1fr',
    gridTemplateRows: 'auto 1fr',
    height: '100vh',
    gridTemplateAreas: `"header header"
            "sidebar main"`,
    '@media (max-width: 640px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto 1fr',
      gridTemplateAreas: `"header"
                "sidebar"
                "main"`,
    },
    overflowY: 'hidden',
  },
  sideBarCollapsed: {
    gridTemplateColumns: '50px 1fr',
  },
  header: {
    gridArea: 'header',
    position: 'sticky',
    top: 0,
    height: '50px',
  },
  sidebar: {
    gridArea: 'sidebar',
    position: 'sticky',
    alignSelf: 'start',
    height: '100%',
    borderRight: `1px solid ${tokens.colorNeutralStroke1}`,
    top: '50px',
    '@media (max-width: 640px)': {
      position: 'revert',
      top: '50px',
      height: 'auto',
      ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke1),
    },
    backgroundColor: tokens.colorNeutralBackground3,
  },
  main: {
    gridArea: 'main',
    overflowY: 'auto',
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
    backgroundColor: tokens.colorNeutralBackground3
  },
  mainScroll: {
    maxHeight: '100%',
    maxWidth: '100%',
    height: '100%',
    width: '100%',
    overFlow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
});
